import { ScrollLock } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import React from 'react';
import * as ReactModal from 'react-modal';

import { getTranslation, keys } from '../../../Resources/Translations';

interface IModalProps {
    open: boolean;
    hideCloseButton?: boolean;
    onClose: () => void;
    className?: string;
    overlayClassName?: string;
    children: React.ReactNode;
    priority?: boolean;
    id?: string;
}

export const Modal = (props: IModalProps) => {
    return (
        <ReactModal
            id={props.id}
            isOpen={props.open}
            shouldCloseOnOverlayClick={!props.hideCloseButton}
            onRequestClose={props.onClose}
            className={classNames('Modal', props.className)}
            overlayClassName={classNames(
                'ModalOverlay',
                props.hideCloseButton && 'ModalOverlay--Disabled',
                props.overlayClassName,
                props.priority && 'ModalOverlay--Priority'
            )}
            ariaHideApp={false}
        >
            {!props.hideCloseButton && (
                <button className="Modal__CloseButton" onClick={props.onClose}>
                    <span className="visuallyHidden">{getTranslation(keys['navigation.close'])}</span>
                </button>
            )}
            <ScrollLock isLocked={props.open} />
            {props.children}
        </ReactModal>
    );
};

export const ModalContent = ({ children, narrow }: { children: React.ReactNode; narrow?: boolean }) => {
    return <div className={classNames('Modal__Content', narrow && 'Modal__Content--Narrow')}>{children}</div>;
};

export const ModalHeading = ({ children }: { children: React.ReactNode }) => {
    return <h2 className="Modal__Heading">{children}</h2>;
};

export const ModalHeader = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="Modal__Header">
            <h2>{children}</h2>
        </div>
    );
};

export const ModalText = ({ children }: { children: React.ReactNode }) => {
    return <p className="Modal__Text">{children}</p>;
};

export enum ModalButtonsDirection {
    Row,
    Column
}

interface IModalButtonsProps {
    children: React.ReactNode;
    direction?: ModalButtonsDirection;
}

export const ModalButtons = (props: IModalButtonsProps) => {
    const direction = `Modal__Buttons--${ModalButtonsDirection[props.direction || ModalButtonsDirection.Row]}`;

    return <div className={classNames('Modal__Buttons', direction)}>{props.children}</div>;
};

export const ModalError = ({ children }: { children: string }) => {
    return <span className="Modal__Error">{children}</span>;
};
